import { Badge, NumberFormatter, Table } from "@mantine/core";

function LedgerTable({ ledger }) {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Date</Table.Th>
          <Table.Th>Type</Table.Th>
          <Table.Th ta="right">Credits</Table.Th>
          <Table.Th>Note</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {ledger.map((p) => (
          <Table.Tr key={p.id}>
            <Table.Td>{p.idCreated}</Table.Td>
            <Table.Td>
              {p.creditType?<Badge>{p.creditType}</Badge>:null}
              {p.isOverwrite ? <Badge color="red">Overwrite</Badge> : null}
            </Table.Td>
            <Table.Td ta="right">
              <NumberFormatter thousandSeparator value={p.creditChange} />
            </Table.Td>
            <Table.Td>{p.notes}</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}

export default LedgerTable;
